import { FormGroup, FormBuilder } from '@angular/forms';
import { TipoFiltro } from './../model/filtro-fundo';
import { MultiplosFiltrosService } from './multiplos-filtros.service';
import { Momento } from 'src/app/domain/primecap/model/momento';
import { Setor } from 'src/app/domain/primecap/model/setor';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CheckboxFiltro } from '../model/checkbox-filtro';
import { FiltroFundo, FiltroUuid } from '../model/filtro-fundo';

@Component({
  selector: 'multiplos-filtros',
  templateUrl: './multiplos-filtros.component.html',
  styleUrls: ['./multiplos-filtros.component.css']
})
export class MultiplosFiltrosComponent implements OnInit {

  abrirPainelSetores = false;
  abrirPainelMomentos = false;
  listaSetores: CheckboxFiltro[];
  listaMomentos: CheckboxFiltro[];
  filtros: FiltroUuid[] = [];
  tipoFiltro = TipoFiltro;
  chequeMinimo: number = 0;
  chequeMaximo: number = 0;
  form: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private filtrosService: MultiplosFiltrosService
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe(
      data => {
        this.listaMomentos = (data.momentos.dados[0].content as Momento[])
        .map(m => new CheckboxFiltro(m.nome, m.uuid, false));
        this.listaSetores = (data.setores.dados[0].content as Setor[])
        .map(s => new CheckboxFiltro(s.nome, s.uuid, false));
      }
    );

    this.form = this.formBuilder.group({
      valorCheque: null,
    });
  }

  adicionarFiltroCheckbox(evento: CheckboxFiltro, checkLabel: TipoFiltro) {
    if (evento.checked) {
      this.filtros.push({
        uuid: evento.uuid,
        nome: evento.nome,
        tipo: checkLabel,
      });
    } else {
      this.filtros = this.filtros.filter(f => f.nome != evento.nome);
    }
  }

  aplicarFiltroFundo() {
    let filtro: FiltroFundo = {
      valorCheque: this.form.get('valorCheque').value,
      listaMomento: this.filtros.filter(f => f.tipo == TipoFiltro.M).map(f => f.uuid),
      listaSetor: this.filtros.filter(f => f.tipo == TipoFiltro.S).map(f => f.uuid)
    }
    this.filtrosService.filtroFundoCriado(filtro);
  }

  limparFiltro() {
    this.form.reset();
    this.filtros = [];
    this.filtrosService.filtroFundoRemovido();
  }
}

